import React, { useState } from 'react';
import { IonIcon, IonSpinner } from '@ionic/react';
import { documentAttachOutline } from 'ionicons/icons';
import { Browser } from '@capacitor/browser';
import { ChatAttachmentRef } from '../../../models';
import { chatsService } from '../../../services';

interface Props {
    attachment: ChatAttachmentRef;
}

const ChatAttachmentCard: React.FC<Props> = ({ attachment }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            const url = await chatsService.getAttachmentUrl(attachment.id);
            if (url) {
                // popover: Capacitor 7's default iOS path presents on a scene-less window, invisible under UIScene
                await Browser.open({ url, presentationStyle: 'popover' });
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="chat-attachment-card" onClick={handleClick} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 8px', borderRadius: '8px', background: 'rgba(0,0,0,0.06)', marginBottom: '4px' }}>
            {isLoading
                ? <IonSpinner name="crescent" style={{ width: '18px', height: '18px' }} />
                : <IonIcon icon={documentAttachOutline} style={{ fontSize: '18px' }} />
            }
            <span style={{ fontSize: '0.85em', wordBreak: 'break-all' }}>{attachment.filename}</span>
        </div>
    );
};

export default ChatAttachmentCard;
